/* LittleBird wallpaper PDP · lb-wallpaper.js
   Exact wall area (sq ft) → max(area, min order) → MRP = rate/sq ft × chargeSqFt
   Cart qty = 1; variant.price = paise per sq ft
*/
(function () {
  var CM_PER_IN = 2.54;
  var CM2_PER_SQFT = 929.0304;
  var SQFT_PER_SQMT = 10.76391041671;

  function money(cents, format) {
    var amount = (Number(cents) / 100).toFixed(2);
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var formatStr = format || 'Rs. {{amount}}';
    if (formatStr.indexOf('{{amount_no_decimals}}') !== -1) {
      return formatStr.replace('{{amount_no_decimals}}', Math.round(Number(cents) / 100).toLocaleString('en-IN'));
    }
    return formatStr
      .replace('{{amount}}', withCommas)
      .replace('{{amount_with_comma_separator}}', withCommas.replace('.', ','));
  }

  function toCm(value, unit) {
    var n = parseFloat(value);
    if (!isFinite(n) || n <= 0) return 0;
    return unit === 'in' ? n * CM_PER_IN : n;
  }

  function fromCm(cm, unit) {
    if (unit === 'in') return cm / CM_PER_IN;
    return cm;
  }

  function ftLabel(cm) {
    var ft = cm / 30.48;
    return (Math.round(ft * 10) / 10).toFixed(1);
  }

  function formatDim(cm, unit) {
    var v = fromCm(cm, unit);
    return unit === 'in' ? Math.round(v * 10) / 10 : Math.round(v);
  }

  /** Parse "16:9", "16/9", or decimal "1.777" → width/height ratio, or 0 if unset/invalid */
  function parseMuralRatio(raw) {
    if (raw == null || raw === '') return 0;
    var s = String(raw).trim();
    if (!s) return 0;
    var parts = s.split(/[:\/xX]/);
    if (parts.length === 2) {
      var a = parseFloat(parts[0]);
      var b = parseFloat(parts[1]);
      if (isFinite(a) && isFinite(b) && a > 0 && b > 0) return a / b;
    }
    var n = parseFloat(s);
    return isFinite(n) && n > 0 ? n : 0;
  }

  function init(root) {
    if (!root || root.dataset.lbWallpaperReady) return;
    root.dataset.lbWallpaperReady = '1';

    var trimPercent = parseFloat(root.getAttribute('data-trim-percent') || '0');
    if (!isFinite(trimPercent) || trimPercent < 0) trimPercent = 0;
    var minOrderSqFt = parseFloat(root.getAttribute('data-min-order-sqft') || '30');
    if (!isFinite(minOrderSqFt) || minOrderSqFt < 0) minOrderSqFt = 30;
    var muralRatio = parseMuralRatio(root.getAttribute('data-mural-ratio'));
    var moneyFormat = root.getAttribute('data-money-format') || 'Rs. {{amount}}';
    var productTitle = root.getAttribute('data-product-title') || '';
    var whatsappPhone = (root.getAttribute('data-whatsapp-phone') || '').replace(/\D/g, '');

    var form = root.querySelector('[data-lb-wallpaper-form]');
    var widthInput = root.querySelector('[data-lb-width]');
    var heightInput = root.querySelector('[data-lb-height]');
    var unitButtons = root.querySelectorAll('[data-lb-unit]');
    var widthLabel = root.querySelector('[data-lb-width-label]');
    var heightLabel = root.querySelector('[data-lb-height-label]');
    var sampleNote = root.querySelector('[data-lb-sample-note]');
    var muralNote = root.querySelector('[data-lb-mural-note]');
    var mrpEl = root.querySelector('[data-lb-mrp]');
    var areaEl = root.querySelector('[data-lb-area]');
    var qtyNoteEl = root.querySelector('[data-lb-qty-note]');
    var selectedFinishLabel = root.querySelector('[data-lb-selected-finish-label]');
    var placeBtn = root.querySelector('[data-lb-place-order]');
    var waBtn = root.querySelector('[data-lb-whatsapp]');

    var variantIdInput = root.querySelector('[data-lb-variant-id]');
    var quantityInput = root.querySelector('[data-lb-quantity]');
    var propWidth = root.querySelector('[data-lb-prop-width]');
    var propHeight = root.querySelector('[data-lb-prop-height]');
    var propUnit = root.querySelector('[data-lb-prop-unit]');
    var propArea = root.querySelector('[data-lb-prop-area]');
    var propFinish = root.querySelector('[data-lb-prop-finish]');
    var propRate = root.querySelector('[data-lb-prop-rate]');
    var propMrp = root.querySelector('[data-lb-prop-mrp]');
    var propTrim = root.querySelector('[data-lb-prop-trim]');

    var syncingRatio = false;

    var state = {
      unit: 'cm',
      widthCm: parseFloat(root.getAttribute('data-default-width') || '240') || 240,
      heightCm: parseFloat(root.getAttribute('data-default-height') || '230') || 230,
      variantId: variantIdInput ? variantIdInput.value : '',
      variantTitle: propFinish ? propFinish.value : '',
      variantPrice: 0,
      available: true
    };

    var single = root.querySelector('[data-lb-single-variant]');
    if (single) {
      try {
        var sv = JSON.parse(single.textContent);
        state.variantId = String(sv.id);
        state.variantTitle = sv.title || 'Default';
        state.variantPrice = Number(sv.price) || 0;
        state.available = !!sv.available;
      } catch (e) {}
    } else {
      var selected = root.querySelector('[data-lb-finish].is-selected');
      if (selected) {
        state.variantId = selected.getAttribute('data-variant-id');
        state.variantTitle = selected.getAttribute('data-variant-title') || '';
        state.variantPrice = Number(selected.getAttribute('data-variant-price') || 0);
        state.available = selected.getAttribute('data-variant-available') !== 'false';
      }
    }

    if (muralRatio > 0 && state.widthCm > 0) {
      state.heightCm = state.widthCm / muralRatio;
    }

    if (muralNote) {
      if (muralRatio > 0) {
        muralNote.hidden = false;
        muralNote.textContent = 'This mural keeps a fixed ratio. Changing width or height updates the other side.';
      } else {
        muralNote.hidden = true;
      }
    }

    function syncInputsFromState() {
      if (!widthInput || !heightInput) return;
      widthInput.value = formatDim(state.widthCm, state.unit);
      heightInput.value = formatDim(state.heightCm, state.unit);
      if (widthLabel) widthLabel.textContent = 'Width (' + state.unit + ')';
      if (heightLabel) heightLabel.textContent = 'Height (' + state.unit + ')';
    }

    function calc() {
      var rawSqFt = (state.widthCm * state.heightCm) / CM2_PER_SQFT;
      var billableSqFt = rawSqFt * (1 + trimPercent / 100);
      var chargeSqFt = Math.max(billableSqFt, minOrderSqFt);
      var minApplied = chargeSqFt > billableSqFt + 1e-9;
      var qty = 1;
      var mrpCents = Math.round(state.variantPrice * chargeSqFt);
      var cartCents = state.variantPrice * qty;
      var chargeSqMt = chargeSqFt / SQFT_PER_SQMT;
      var rawSqMt = rawSqFt / SQFT_PER_SQMT;

      return {
        rawSqFt: rawSqFt,
        billableSqFt: billableSqFt,
        chargeSqFt: chargeSqFt,
        minApplied: minApplied,
        qty: qty,
        mrpCents: mrpCents,
        cartCents: cartCents,
        rawSqMt: rawSqMt,
        chargeSqMt: chargeSqMt
      };
    }

    function render() {
      var c = calc();
      var wStr = formatDim(state.widthCm, state.unit);
      var hStr = formatDim(state.heightCm, state.unit);

      if (sampleNote) {
        sampleNote.textContent =
          'Sample price for a ' +
          wStr +
          ' × ' +
          hStr +
          ' ' +
          state.unit +
          ' (≈ ' +
          ftLabel(state.widthCm) +
          ' × ' +
          ftLabel(state.heightCm) +
          ' ft) wall — enter your wall size to order.';
      }

      if (mrpEl) {
        mrpEl.textContent =
          'MRP (inclusive of taxes): ' +
          money(c.mrpCents, moneyFormat) +
          (state.variantTitle ? ' | ' + state.variantTitle : '');
      }

      if (areaEl) {
        var areaText =
          'Area: ' +
          c.chargeSqFt.toFixed(1) +
          ' sq ft (' +
          c.chargeSqMt.toFixed(2) +
          ' sq mt)';
        if (c.minApplied) {
          areaText +=
            ' · Minimum order ' + minOrderSqFt + ' sq ft applied (wall is ' + c.rawSqFt.toFixed(1) + ' sq ft)';
        } else if (trimPercent > 0) {
          areaText += ' · includes ' + trimPercent + '% extra for trimming';
        } else {
          areaText += ' · exact wall size (no trim)';
        }
        areaEl.textContent = areaText;
      }

      if (qtyNoteEl) {
        qtyNoteEl.textContent =
          'Ordered as 1 made-to-measure piece · ' +
          c.chargeSqFt.toFixed(1) +
          ' sq ft × ' +
          money(state.variantPrice, moneyFormat) +
          '/sq ft.';
      }

      if (variantIdInput) variantIdInput.value = state.variantId;
      if (quantityInput) quantityInput.value = String(c.qty);
      if (propWidth) propWidth.value = wStr + ' ' + state.unit;
      if (propHeight) propHeight.value = hStr + ' ' + state.unit;
      if (propUnit) propUnit.value = state.unit;
      if (propArea) {
        propArea.value =
          c.chargeSqFt.toFixed(2) +
          ' sq ft charged' +
          (c.minApplied ? ' (min ' + minOrderSqFt + ' sq ft; wall ' + c.rawSqFt.toFixed(2) + ' sq ft)' : '') +
          (trimPercent > 0 ? '; ' + trimPercent + '% trim' : '');
      }
      if (propFinish) propFinish.value = state.variantTitle;
      if (propRate) propRate.value = money(state.variantPrice, moneyFormat) + ' per sq ft';
      if (propMrp) propMrp.value = money(c.mrpCents, moneyFormat);
      if (propTrim) {
        propTrim.value =
          trimPercent > 0 ? trimPercent + '% extra for trimming' : '0% — exact wall size (no trim)';
      }

      if (placeBtn) {
        placeBtn.disabled = !state.available || c.qty < 1 || state.widthCm <= 0 || state.heightCm <= 0;
      }

      updateWhatsApp(c, wStr, hStr);
    }

    function updateWhatsApp(c, wStr, hStr) {
      if (!waBtn) return;
      if (!whatsappPhone) {
        waBtn.setAttribute('aria-disabled', 'true');
        waBtn.href = '#';
        return;
      }
      waBtn.removeAttribute('aria-disabled');
      var msg =
        'Hi LittleBird, I need help with wallpaper.\n' +
        'Product: ' +
        productTitle +
        '\n' +
        'Finish: ' +
        (state.variantTitle || 'Not selected') +
        '\n' +
        'Wall size: ' +
        wStr +
        ' × ' +
        hStr +
        ' ' +
        state.unit +
        '\n' +
        'Chargeable area: ' +
        c.chargeSqFt.toFixed(1) +
        ' sq ft\n' +
        'Estimated MRP: ' +
        money(c.mrpCents, moneyFormat);
      waBtn.href = 'https://wa.me/' + whatsappPhone + '?text=' + encodeURIComponent(msg);
      waBtn.target = '_blank';
      waBtn.rel = 'noopener';
    }

    unitButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = btn.getAttribute('data-lb-unit');
        if (!next || next === state.unit) return;
        state.unit = next;
        unitButtons.forEach(function (b) {
          var on = b.getAttribute('data-lb-unit') === state.unit;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        syncInputsFromState();
        render();
      });
    });

    function onWidthInput() {
      if (syncingRatio) return;
      state.widthCm = toCm(widthInput && widthInput.value, state.unit);
      if (muralRatio > 0 && state.widthCm > 0) {
        syncingRatio = true;
        state.heightCm = state.widthCm / muralRatio;
        if (heightInput) heightInput.value = formatDim(state.heightCm, state.unit);
        syncingRatio = false;
      }
      render();
    }

    function onHeightInput() {
      if (syncingRatio) return;
      state.heightCm = toCm(heightInput && heightInput.value, state.unit);
      if (muralRatio > 0 && state.heightCm > 0) {
        syncingRatio = true;
        state.widthCm = state.heightCm * muralRatio;
        if (widthInput) widthInput.value = formatDim(state.widthCm, state.unit);
        syncingRatio = false;
      }
      render();
    }

    function readDimensions() {
      state.widthCm = toCm(widthInput && widthInput.value, state.unit);
      state.heightCm = toCm(heightInput && heightInput.value, state.unit);
      if (muralRatio > 0 && state.widthCm > 0) {
        state.heightCm = state.widthCm / muralRatio;
        syncInputsFromState();
      }
      render();
    }

    if (widthInput) widthInput.addEventListener('input', onWidthInput);
    if (heightInput) heightInput.addEventListener('input', onHeightInput);

    root.querySelectorAll('[data-lb-finish]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        root.querySelectorAll('[data-lb-finish]').forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
          b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
        });
        state.variantId = btn.getAttribute('data-variant-id');
        state.variantTitle = btn.getAttribute('data-variant-title') || '';
        state.variantPrice = Number(btn.getAttribute('data-variant-price') || 0);
        state.available = btn.getAttribute('data-variant-available') !== 'false';
        if (selectedFinishLabel) selectedFinishLabel.textContent = state.variantTitle;
        if (variantIdInput) {
          variantIdInput.value = state.variantId;
          variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        render();
      });
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        readDimensions();
        if (placeBtn && placeBtn.disabled) return;

        var c = calc();
        if (quantityInput) quantityInput.value = String(c.qty);
        if (variantIdInput) variantIdInput.value = state.variantId;

        placeBtn.setAttribute('aria-busy', 'true');
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

        var sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:prepare-bundled-sections', {
            bubbles: true,
            detail: { sections: sectionsToBundle }
          })
        );

        var formData = new FormData(form);
        formData.set('sections', sectionsToBundle.join(','));
        formData.set(
          'sections_url',
          (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'variants/' + state.variantId
        );

        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (res) {
            return res.json().then(function (json) {
              return { ok: res.ok, json: json };
            });
          })
          .then(function (result) {
            placeBtn.removeAttribute('aria-busy');
            document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
            if (!result.ok) {
              form.dispatchEvent(
                new CustomEvent('cart:error', {
                  bubbles: true,
                  detail: { error: result.json.description || 'Could not add to cart' }
                })
              );
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              return;
            }
            return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js')
              .then(function (r) {
                return r.json();
              })
              .then(function (cart) {
                cart.sections = result.json.sections;
                form.dispatchEvent(
                  new CustomEvent('variant:add', {
                    bubbles: true,
                    detail: {
                      items: result.json.items || [result.json],
                      cart: cart
                    }
                  })
                );
                document.documentElement.dispatchEvent(
                  new CustomEvent('cart:change', {
                    bubbles: true,
                    detail: { baseEvent: 'variant:add', cart: cart }
                  })
                );
              });
          })
          .catch(function () {
            placeBtn.removeAttribute('aria-busy');
            document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
          });
      });
    }

    syncInputsFromState();
    render();
  }

  function boot() {
    document.querySelectorAll('[data-lb-wallpaper]').forEach(init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
